import React, {Component} from 'react';
import {
  Button,
  Table
} from 'reactstrap';


import { FaPencilAlt, FaTrashAlt, FaCheck, FaTimes} from 'react-icons/fa';



class TablaTipoUsuario extends Component {

    checkeado = (dato) => {
        let resultado = dato==="1" ? <FaCheck color="green" /> : <FaTimes color="red" />; 
        return resultado;
    }

    render(){
        const {data , eliminar, editar } = this.props; 
       // const info = data!=='' && data!==undefined ? data : []; 

        return (
                <Table size="sm" striped bordered className="tabla-general">

                    <thead>
                        <tr>
                            <th className="ocultar-en-somen">Nombre</th>
                            <th className="ocultar-en-somen">Descripción</th>
                            <th className="text-center ocultar-en-somen">1</th>
                            <th className="text-center ocultar-en-somen">2</th>
                            <th className="text-center ocultar-en-somen">3</th>
                            <th className="text-center ocultar-en-somen">4</th>
                            <th className="text-center ocultar-en-somen">5</th>
                            <th className="text-center ocultar-en-somen">6</th>
                            <th className="text-center ocultar-en-somen">7</th>
                            <th className="text-center ocultar-en-somen">8</th>
                            <th className="text-center ocultar-en-somen">9</th>
                            <th className="text-center ocultar-en-somen">10</th>
                            <th className="text-center ocultar-en-somen">11</th>
                            <th className="text-center ocultar-en-somen">12</th>
                            <th className="text-center ocultar-en-somen">13</th>
                            <th className="ocultar-m-omas">Tipo de usuario</th>
                            <th className="text-center">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map(t => {
                            return(
                                <tr key={t.id}>
                                    <td className="ocultar-en-somen">{t.nombre}</td>
                                    <td className="ocultar-en-somen">{t.descripcion}</td>

                                    <td className="text-center ocultar-en-somen">{this.checkeado(t.mod_blog)}</td>
                                    <td className="text-center ocultar-en-somen">{this.checkeado(t.mod_galeria)}</td>
                                    <td className="text-center ocultar-en-somen">{this.checkeado(t.mod_cursos)}</td>
                                    <td className="text-center ocultar-en-somen">{this.checkeado(t.mod_anuncios)}</td>
                                    <td className="text-center ocultar-en-somen">{this.checkeado(t.mod_calificaciones)}</td>
                                    <td className="text-center ocultar-en-somen">{this.checkeado(t.mod_material)}</td>
                                    <td className="text-center ocultar-en-somen">{this.checkeado(t.mod_postulaciones)}</td>
                                    <td className="text-center ocultar-en-somen">{this.checkeado(t.mod_usuarios)}</td>
                                    <td className="text-center ocultar-en-somen">{this.checkeado(t.mod_tipousuarios)}</td>
                                    <td className="text-center ocultar-en-somen">{this.checkeado(t.mod_estudiantes)}</td>
                                    <td className="text-center ocultar-en-somen">{this.checkeado(t.mod_ver_anuncios)}</td>
                                    <td className="text-center ocultar-en-somen">{this.checkeado(t.mod_ver_calificaciones)}</td>
                                    <td className="text-center ocultar-en-somen">{this.checkeado(t.mod_ver_material)}</td> 
                                    <td className="ocultar-m-omas">
                                        <div>
                                            {t.nombre} : {t.descripcion}
                                        </div>
                                        <hr/>
                                        <div>
                                            <span className="modsm">1: {this.checkeado(t.mod_blog)}</span>
                                            <span className="modsm">2: {this.checkeado(t.mod_galeria)}</span>
                                            <span className="modsm">3: {this.checkeado(t.mod_cursos)}</span>
                                            <span className="modsm">4: {this.checkeado(t.mod_anuncios)}</span>
                                            <span className="modsm">5: {this.checkeado(t.mod_calificaciones)}</span>
                                            <span className="modsm">6: {this.checkeado(t.mod_material)}</span>
                                            <span className="modsm">7: {this.checkeado(t.mod_postulaciones)}</span>
                                            <span className="modsm">8: {this.checkeado(t.mod_usuarios)}</span>
                                            <span className="modsm">9: {this.checkeado(t.mod_tipousuarios)}</span>
                                            <span className="modsm">10: {this.checkeado(t.mod_estudiantes)}</span>
                                            <span className="modsm">11: {this.checkeado(t.mod_ver_anuncios)}</span>
                                            <span className="modsm">12: {this.checkeado(t.mod_ver_calificaciones)}</span>
                                            <span className="modsm">13: {this.checkeado(t.mod_ver_material)}</span>
                                        </div>
                                    </td>
                                    <td className="text-center td-botones">
                                        {t.id!=='1' && t.id!=='2' && t.id!=='3' ?
                                            <span>
                                                <Button color="secondary" className="btn-tabla" onClick={()=>editar(t)} > <FaPencilAlt/></Button>
                                                <Button color="danger" className="btn-tabla" onClick={()=>eliminar(t.id)}><FaTrashAlt/></Button>
                                            </span>
                                            : 
                                            <Button color="secondary" className="btn-tabla" onClick={()=>editar(t)} > <FaPencilAlt/></Button>
                                        }
                                       
                                    </td>
                                </tr>  
                            )
                        })}



                    </tbody>




                </Table>    

        );

    }
};

export default TablaTipoUsuario;
